import { Button, Container, Grid2, Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { actions as loginActions } from "components/login/logic/actions";
import log from "loglevel";
import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "../common/Select";
import AdvertisementAssociationInformation from "./AdvertisementAssociationInformation";
import FilmInformationForm from "./AdvertisementFilmInformation";
import AdvertisementInformation from "./AdvertisementInformation";
import { actions } from "./logic/formActions";

import CompanySelect from "components/global/CompanySelect";
import FilmReleaseSelect from "components/global/FilmReleaseSelect";
import { styles } from "./styles";

import { debounce } from "lodash";

class AdvertisingSearch extends Component {
    constructor(props) {
        super(props);
        this.onInput = debounce(this.onInput, 300);
    }

    state = {
        filmRelease: false,
        filmCompany: false,
        filmValue: "",
    };

    componentDidMount() {}

    onChange = (e) => {
        log.debug("***onchange", e);
        log.debug("---test", Object.entries(e));
        this.props.changeForm({
            attribute: e.target.name,
            value: e.target.value,
        });

        if (e.target.name === "filmCompany") {
            this.props.changeForm({
                attribute: "filmRelease",
                value: null,
            });
        }
    };

    onInput = (e, a) => {
        log.debug("e from input", e);
        log.debug("e.value type", typeof e.target.value);
        log.debug(a);
        if (a && a.action.match(/input-blur|menu-close/)) return;

        this.setState({
            [e.target.name]: false,
        });

        if (e.target.name === "filmRelease") {
            this.setState({ filmValue: e.target.value });
            if (e.target.value.length > 2)
                this.props.getFilmByTitle({
                    titlePattern: e.target.value,
                    companyIds: this.props.filmCompany && this.props.filmCompany.value,
                });
        } else if (e.target.name === "filmCompany" && e.target.value.length > 2) {
            log.debug("from input");
            this.props.getCompanyByTitle(e.target.value);
        } else {
            if (e.target.value !== "")
                this.setState({
                    [e.target.name]: true,
                });
        }
    };

    onKeyDown = (e, model) => {
        if (e.keyCode === 13) {
            switch (model) {
            case "film":
                this.props.getFilmByTitle({
                    titlePattern: this.state.filmValue,
                    companyIds: this.props.filmCompany && this.props.filmCompany.value,
                });
                break;
            case "company":
                this.props.getCompanyByTitle(this.state.companyValue);
                break;
            }
        }
    };

    onChangeCompanySelect = (value) => {
        this.props.changeForm({
            attribute: "filmCompany",
            value,
        });
    };
    onChangeFilm = (value) => {
        this.onChange({ target: { value, name: "filmRelease" } });
    };
    render() {
        const {
            advertisementTypes,
            advType,
            classes,
            filmRelease,
            filmCompany,

            isSmallDevice,
        } = this.props;

        const advTypes = advertisementTypes.map((type) => ({ value: type.id, label: type.name }));
        const component = (
            <Grid2 className={`search-grid ${isSmallDevice ? "" : classes.searchContainer}`} container spacing={2}>
                {!isSmallDevice && (
                    <Grid2 paddingRight={5} paddingLeft={2} className={classes.formHeader} size={12}>
                        <div className={classes.formHeaderItem}>
                            <Typography variant="h5">Filter by:</Typography>
                        </div>
                        <div className={classes.formHeaderItem}>
                            <Button size={"small"} variant={"outlined"} onClick={this.props.clearForm}>
                                Reset
                            </Button>
                        </div>
                    </Grid2>
                )}
                <Grid2 size={12} paddingLeft={4} paddingRight={5}>
                    <FilmReleaseSelect defaultValue={filmRelease} onChange={this.onChangeFilm} />
                </Grid2>

                <Grid2 size={12} paddingLeft={4} paddingRight={5}>
                    <CompanySelect onChange={this.onChangeCompanySelect} defaultValue={filmCompany} />
                </Grid2>
                <Grid2 style={{ marginBottom: 20 }} size={12} paddingLeft={4} paddingRight={5}>
                    <Select
                        placeholder="All Advertising Types"
                        value={advType}
                        multiple
                        defaultMenuPortalTarget
                        onChange={(e) => this.onChange({ target: { value: e, name: "advType" } })}
                        options={advTypes}
                    />
                </Grid2>
                <Grid2 size={12}>
                    <AdvertisementInformation onChange={this.onChange} />
                </Grid2>
                <Grid2 size={12}>
                    <FilmInformationForm onChange={this.onChange} />
                </Grid2>
                <Grid2 size={12}>
                    <AdvertisementAssociationInformation onChange={this.onChange} />
                </Grid2>
            </Grid2>
        );

        return isSmallDevice ? <Container style={{ paddingTop: 10, paddingBottom: 5 }}>{component}</Container> : component;
    }
}

const mapStateToProps = ({
    advertising: {
        form: { advType, filmRelease, filmCategory, filmCompany },
        filmTitles,

        loadFilmTitles,
    },
    login: { user },
    globalApp,
}) => ({
    advertisementTypes: globalApp.advertisementTypes,
    advType,
    filmRelease,
    filmCategory,
    filmCompany,
    filmTitles,
    filmCompanies: globalApp.filmCompanies,
    loadFilmTitles,
    user,
});

const mapDispatchToProps = (dispatch) => ({
    changeForm: (payload) => dispatch(actions.CHANGE_FORM.send(payload)),
    clearForm: () => dispatch(actions.CLEAR_FORM.call()),
    getAdvertisementTypes: (url) => dispatch(actions.GET_ADVERTISEMENT_TYPE.send(url)),
    getFilmByTitle: (payload) => dispatch(actions.GET_FILM_TITLE.send(payload)),
    loadUserInfoFromStorage: (payload) => dispatch(loginActions.LOAD_USER.call(payload)),
    getUserInfo: () => dispatch(loginActions.INFO_USER.send()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AdvertisingSearch));
